<script setup lang="ts">
defineProps<{
  modelValue?: string
  name?: string
  label?: string
  checked?: boolean
  value?: string
  id?: string
}>()

defineEmits<{
  (e: 'change', value?: string): void
}>()
</script>

<template>
  <div class="mb-4 mr-8 flex items-center">
    <input
      :id="id"
      type="radio"
      :value="value"
      :name="name"
      :checked="value === modelValue"
      class="hidden"
      @change="$emit('change', value)"
    />
    <label :for="id" class="flex cursor-pointer items-center">
      <span class="border-grey mr-4 inline-block h-4 w-4 rounded-full border-8" />
      {{ label }}</label
    >
  </div>
</template>

<style>
input[type='radio'] + label span {
  transition:
    background 0.2s,
    transform 0.2s;
  border: 8px solid transparent;
  background-color: #d9dbe9;
  padding: 6px;
}

input[type='radio'] + label span:hover,
input[type='radio'] + label:hover span {
  transform: scale(1.2);
}

input[type='radio']:checked + label span {
  box-shadow: 0px 0px 0px 2px white inset;
  border: 8px solid #009b90;
  background-color: white;
  padding: 6px;
}

input[type='radio']:checked + label {
  color: #009b90;
}
input[type='radio'] + label:hover span,
input[type='radio'] + label span:hover {
  transform: scale(1.2);
}
</style>
